<div class="col-md-12 topBar">
  <div class="row m-0 p-0" style="height: 50px;">
    <div class=" col-md-5 headerClasss row m-0 p-0">
      <div class="logoClass" style="margin-top: 10px;margin-bottom: 10px;width: 168px;border-right: 1.5px solid white;">
        <img class="capelogo" src="assets/cape-logo-new.png" alt="CAPE Logo">
      </div>
      <div class="col headerLabelClass">Trust Centre</div>


    </div>
    <div class="col-md-2 m-0 p-0"></div>
    <div class="col-md-5 m-0 p-0">
      <div class="row m-0 p-0 h-100">
        <div class="col-md-4 m-0 p-0">
          <div class="moveMenu row m-0 p-0">
            <button class="btnsignin" (click)="signin()">Sign in</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div  class="container-fluid">
    <mat-tab-group #tabGroup (selectedTabChange)="tabClick($event)" [selectedIndex]="selectedIndexVal">
        <mat-tab label="Notices" >
            <div style="padding-top: 10px;">
                <button class="btn btn-danger" (click)="downloadpdffile()">Downloadpdf</button>
                <button (click)="viewHtml()">View HTML</button>

               
                <div *ngIf="blobUrl">
                    <pdf-viewer [src]="safeurl?.changingThisBreaksApplicationSecurity" [original-size]="false"></pdf-viewer>
                  </div>
 
               
            </div>
        </mat-tab>
        <mat-tab label="General T & C" >
            <div style="padding-top: 10px;">
            </div>
        </mat-tab>
        <mat-tab label="Privacy Notice" >
            <div style="padding-top: 10px;">
            </div>
        </mat-tab>
    </mat-tab-group>
</div> -->


<!-- <div *ngFor="let t of tabList" > -->
<div class="container-fluid">
  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="getDocumentsListFromCategory($event)">
    <mat-tab *ngFor="let t of tabList; let i = index" [label]="t">
      <div>
        <div class="row">
          <div *ngFor="let n of documentsList">
            <!-- <mat-card  class="m-2" appearance="outlined">
                            <mat-card-header>
                                <mat-card-title>  
                                    <div class="heading" >
                                        <div>{{n.doc_name}}</div>
                                        <mat-icon style="cursor: pointer;" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" >more_vert</mat-icon>
                                        <mat-menu #menu="matMenu">
                                        <button (click)="viewdata(n)" mat-menu-item>
                                          <mat-icon>visibility</mat-icon>
                                          <span>View</span>
                                        </button>
                                        <button (click)="downloaddata(n)" mat-menu-item>
                                          <mat-icon>save_alt</mat-icon>
                                          <span>Download</span>
                                        </button>
                                      </mat-menu>
                                        
                                    </div>
                                      
                                </mat-card-title>
                              <mat-card-subtitle>Version: {{n.doc_version}}</mat-card-subtitle>
                              <mat-card-subtitle>{{n.uploaded_on | date}}</mat-card-subtitle>
                            </mat-card-header>
                            
                          </mat-card> -->
            <!-- <button class="btn btn-danger" (click)="downloaddata(n)">Downloadpdf</button> -->
            <!-- <div class="uploadedDate">Last Uploaded on {{n.uploaded_on | date}}</div> -->
            <app-htmlcontentimmudb [item]="n"></app-htmlcontentimmudb>
          </div>
        </div>
      </div>
      <router-outlet></router-outlet>
    </mat-tab>
  </mat-tab-group>
</div>
<!-- </div> -->
